module.exports = __webpack_public_path__ + "static/media/Group-25@1x.b8b169da.svg";